import BaseDownloadButtonView from "./baseDownloadButtonView";
import bbicoIcon from "templates/downloadButton/bbicoIcon.hbs";

class ListTileDownloadButtonView extends BaseDownloadButtonView {
  constructor(options) {
    super(options);

    this.icon = bbicoIcon;
    this.classNames = "btn circle-btn circle-btn-small btn-download clr-written";
  }
}
export default ListTileDownloadButtonView;
